var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.53033,
    y1: 14.0869,
    x2: 11.3039,
    y2: 24.8605,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2431,
    y1: 24.8603,
    x2: 34.4837,
    y2: 0.619705,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.53033,
    y1: 18.4462,
    x2: 11.3039,
    y2: 29.2198,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2431,
    y1: 29.2197,
    x2: 34.4837,
    y2: 4.97908,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.53033,
    y1: 22.8134,
    x2: 11.3039,
    y2: 33.587,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2431,
    y1: 33.5869,
    x2: 34.4837,
    y2: 9.34627,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.53033,
    y1: 27.1806,
    x2: 11.3039,
    y2: 37.9542,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2431,
    y1: 37.9501,
    x2: 34.4837,
    y2: 13.7095,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0.53033,
    y1: 31.5439,
    x2: 11.3039,
    y2: 42.3175,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2431,
    y1: 42.3173,
    x2: 34.4837,
    y2: 18.0767,
    stroke: "#299F5B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b19e73d032d30b3f6d35caddc3abcd8.svg";
export { ForwardRef as ReactComponent };